import { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { defineMessages, injectIntl } from "react-intl";
import useUserAccount from "../hooks/useUserAccount";
import AlertDialog from "./AlertDialog";
import { useNavigate } from "react-router-dom";

const messages = defineMessages({
    title: {
        id: "Haluatko varmasti sulkea käyttäjätilisi?",
        defaultMessage: "Haluatko varmasti sulkea käyttäjätilisi?"
    },
    confirmationText: {
        id: "Käyttäjätilin sulkeminen johtaa tilin ja kaikkien suostumuksesi perusteella käsiteltyjen henkilötietojen poistamiseen, ja sinut kirjataan ulos. Tämä toimenpide merkitsee myös suostumuksesi peruuttamista henkilötietojen käsittelyyn.",
        defaultMessage: "Käyttäjätilin sulkeminen johtaa tilin ja kaikkien suostumuksesi perusteella käsiteltyjen henkilötietojen poistamiseen, ja sinut kirjataan ulos. Tämä toimenpide merkitsee myös suostumuksesi peruuttamista henkilötietojen käsittelyyn."
    },
    goBack: {
        id: "Palaa takaisin",
        defaultMessage: "Palaa takaisin"
    },
    cancel: {
        id: "Peruuta",
        defaultMessage: "Peruuta"
    },
    confirm: {
        id: "Sulje",
        defaultMessage: "Sulje"
    },
    somethingWentWrong: {
        id: "Tapahtui virhe. Ole hyvä ja yritä uudelleen.",
        defaultMessage: "Tapahtui virhe. Ole hyvä ja yritä uudelleen."
    }
});

const CloseAccountModal = (props) => {
    const lng = props.intl.formatMessage;
    const navigate = useNavigate();
    const [showError, setShowError] = useState(false);
    const [loading, setLoading] = useState(false);
    const { userAccountDelete, companyDataDelete, userIsCompany } = useUserAccount();

    const handleHide = () => {
        props.onHide();
    }

    const handleConfirm = async () => {
        setShowError(false);
        setLoading(true);
        try {
            if (userIsCompany()) {
                await companyDataDelete();
            } else {
                await userAccountDelete();
            }
            handleHide();
            navigate({ pathname: '/logout', search: '?alert=accountDeleted' });
        } catch (error) {
            setShowError(true);
        } finally {
            setLoading(false);
        }
    }

    return (
        <Modal show={props.show} onHide={handleHide} id='close-account-modal'>
            <Modal.Header closeButton>
                <Button
                    disabled={loading}
                    className="modal-back"
                    onClick={handleHide}
                    aria-label={lng(messages.goBack)}
                >
                    <FontAwesomeIcon icon={far.faArrowLeft} aria-hidden="true" /> {lng(messages.goBack)}
                </Button>
                <Modal.Title>{lng(messages.title)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {showError && (
                    <AlertDialog
                        type="danger"
                        message={lng(messages.somethingWentWrong)}
                    />
                )}
                <p>
                    {lng(messages.confirmationText)}
                </p>
                <div className="d-flex gap-3 mt-4">
                    <Button disabled={loading} variant='primary' onClick={handleConfirm}>
                        {loading && (<Spinner animation="border" size="sm" />)} {lng(messages.confirm)}
                    </Button>
                    <Button disabled={loading} variant='secondary' onClick={handleHide}>
                        {lng(messages.cancel)}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

CloseAccountModal.propTypes = {
    intl: PropTypes.object.isRequired,
    show: PropTypes.bool,
    onHide: PropTypes.func
};

export default injectIntl(CloseAccountModal);